import { formatIsoCalendarDate } from '../../../widgets/repository/inputs/date/formatIsoCalendarDate';
import { Datatype } from '../../datatype/Datatype';
import { IReference } from '../IReference';

/**
 * Trasforma il valore di una reference nella stringa da visualizzare,
 * in base al tipo di dato. Al momento gestisce le date (gg/mm/aaaa);
 * gli altri tipi passano invariati.
 */
export function formatReferenceValue(
  reference: IReference,
  value: any,
): string {
  // `field` può mancare nelle reference legacy serializzate nei rich text.
  // Le date viaggiano come stringhe ISO nello stato del form (vedi
  // `stringDate`): per la visualizzazione le portiamo in gg/mm/aaaa.
  if (reference.field?.type === Datatype.Date) {
    return formatIsoCalendarDate(value);
  }

  return value;
}
